import FieldValidator from './_FieldValidator';

export default class ChildInformationFieldValidator extends FieldValidator {
    constructor() {
        super('');
    }

    async validate(value) {
        const messages = [];

        value.forEach((item, index) => {
            const {fieldNamePrefix, firstName, lastName, birthDate} = item;           

            if (firstName.length === 0) {
                messages.push({fieldName: `${fieldNamePrefix}.FirstName`, text: 'Please provide a value for First Name'});
            }
            
            if (lastName.length === 0) {
                messages.push({fieldName: `${fieldNamePrefix}.LastName`, text: 'Please provide a value for Last Name'});
            }
            
            if (birthDate.length === 0) {
                messages.push({fieldName: `${fieldNamePrefix}.BirthDate`, text: 'Please provide a value for Birth Date'});
            }
        });


        if (messages.length === 0) {
            return Promise.resolve({ valid: true });
        }

        return Promise.resolve({ valid: false, messages });
    }
}